
import prdApi from "@config/api";
export  const MsgInFe = [{
    msg:["骚扰电话"],
    reply:{
        data:[{
            type:1,
            returnMessage:window._SOURCE === "ganji" ? "您可以在【个人中心】-【隐私设置】中进行设置，以便不会被打扰" : "您可以在【我的求职】-【隐私设置】中进行设置，以便不会被打扰" , 
            jumpLink:{
                url:window._SOURCE === "ganji" ? "https://gjjl.58.com/resumeupdate/privacysettings" : "https://jianli.m.58.com/userprivacy/privacysettings#/",
                txt:"去设置"
            }
        }]
    }
},{
    msg:["客服电话","客服热线","热线电话"],
    reply:{
        data:window._SOURCE === "ganji"?
        [{
            type:1,
            returnMessage:`客服电话：`,
            tel: true
        }]
        :
        [{
            type:1,
            returnMessage:'很抱歉，此功能暂未开通哦',
        }]
    }
},{
    msg:["求职进度","简历"],
    reply:{
        data:[{
            type:-4,
            url: window._SOURCE === "ganji" ? "https://gjjl.58.com/resumedelivery/applypositionprocessui" : "https://jianli.m.58.com/resumedelivery/m_applypositionhistoryui/1/?from=other",
            title:'申请记录',
            isNeedLog: window._SOURCE === "ganji" ? false : true,
            pageCarrier:"link",
        }]
    }
},{
    msg:["了解会员权益,快速找工作","会员"],
    reply:{
        data:window._SOURCE === "ganji" 
        ?[{
            type:1,
            returnMessage: "该功能暂未开放，敬请期待。"
        }]
        :[{
            type:-2,
            //showType:2,
            logActionType:"mchatbot_cvip_show"
            
        }]
    }
},{
    msg:["求职知识课堂","求职帮助","求职知识","诈骗","求职实力","保障"],
    reply:{
        data:[{
            type:-1,
            logActionType:"mchatbot_zhishiall_show"
        }]
    }
},{
    msg:["小聘使用指南","常见功能"],
    reply:{
        data:[{
            type:-4,
            url:"https://hrgbot.58.com/mcommonchat/manual",
            //isRouter:1,走页面跳转 走路由返回首页页面会重新渲染数据
            //routerPath:'/xiaopin/manual'
        }]
    }
},{
    msg:["去app体验"],
    reply:{
        data:[{
            type:-4,
            url:"https://down.58.com/zt/callappback.html?pagetype=common&tradeline=core&pid=2281&url="+encodeURIComponent(prdApi.jumpUrl.appchatbotindex),
            //isRouter:1,走页面跳转 走路由返回首页页面会重新渲染数据
            //routerPath:'/xiaopin/manual'
        }]
    }
}]





